<div class="tw-flex tw-flex-row tw-items-center tw-gap-1">
  <mg-tt-dropdown-btn
    *ngIf="(isMobile$ | async) === false"
    id="tools-myclass-click-grid-view"
    matTooltipClass="mg-tooltip"
    [dropdown]="false"
    [matTooltip]="MESSAGES.SETTINGS_PAGE_LAYOUT_TOOLTIP"
    [icon]="form.get(FORM_FIELDS.PAGE_LAYOUT).value === 'grid' ? 'mg-table-rows' : 'mg-grid-view'"
    [attr.aria-label]="MESSAGES.ARIA_LABEL_PAGE_LAYOUT"
    (click)="
      form.get(FORM_FIELDS.PAGE_LAYOUT).setValue(form.get(FORM_FIELDS.PAGE_LAYOUT).value === 'grid' ? 'list' : 'grid')
    "></mg-tt-dropdown-btn>
  <mg-tt-dropdown-btn
    icon="mg-show"
    id="tools-myclass-click-visibility-settings"
    matTooltipClass="mg-tooltip"
    (menuOpened)="menuOpened(SETTINGS_MENU.VISIBILITY_SETTINGS)"
    (menuClosed)="menuClosed(SETTINGS_MENU.VISIBILITY_SETTINGS)"
    [matTooltip]="MESSAGES.SETTINGS_VISIBILITY_TOOLTIP"
    [expanded]="openMenu === SETTINGS_MENU.VISIBILITY_SETTINGS"
    [attr.aria-label]="MESSAGES.ARIA_LABEL_INFO_FILTERS"
    [matMenuTriggerFor]="visibilitySettings">
  </mg-tt-dropdown-btn>
  <mg-tt-dropdown-btn
    id="tools-myclass-click-other-settings"
    matTooltipClass="mg-tooltip"
    (menuOpened)="menuOpened(SETTINGS_MENU.NOTIFICATIONS_SETTINGS)"
    (menuClosed)="menuClosed(SETTINGS_MENU.NOTIFICATIONS_SETTINGS)"
    [icon]="form.get(FORM_FIELDS.ENABLED_SOUND).value ? 'mg-notification-sound' : 'mg-notifications-off'"
    [matTooltip]="MESSAGES.SETTINGS_NOTIFICATIONS_TOOLTIP"
    [expanded]="openMenu === SETTINGS_MENU.NOTIFICATIONS_SETTINGS"
    [attr.aria-label]="MESSAGES.ARIA_LABEL_SOUND_NOTIFICATION"
    [matMenuTriggerFor]="notificationSettings"></mg-tt-dropdown-btn>
  <mg-tt-dropdown-btn
    id="tools-myclass-click-other-settings"
    matTooltipClass="mg-tooltip"
    icon="mg-minga-menu-o"
    (menuOpened)="menuOpened(SETTINGS_MENU.OTHER_SETTINGS_MENU)"
    (menuClosed)="menuClosed(SETTINGS_MENU.OTHER_SETTINGS_MENU)"
    [matTooltip]="MESSAGES.SETTINGS_OTHER_SETTINGS_TOOLTIP"
    [expanded]="openMenu === SETTINGS_MENU.OTHER_SETTINGS_MENU"
    [attr.aria-label]="MESSAGES.ARIA_LABEL_SETTINGS"
    [matMenuTriggerFor]="otherSettingsMenu"></mg-tt-dropdown-btn>

  <mat-menu
    #visibilitySettings="matMenu"
    xPosition="before">
    <div
      class="tw-flex tw-flex-column tw-gap-2 tw-p-3"
      (click)="$event.stopPropagation()">
      <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center">
        <div class="tw-flex tw-flex-row tw-items-center">
          <mg-text
            variant="body-sm"
            [color]="(isBehaviorEnabled$ | async) === false ? 'grey-300' : undefined">
            {{ MESSAGES.SETTINGS_SHOW_BEHAVIORS }}
          </mg-text>
          <mg-tooltip [label]="MESSAGES.SETTINGS_SHOW_BEHAVIORS_TOOLTIP"> </mg-tooltip>
        </div>
        <mg-form-toggle
          [disabled]="(isBehaviorEnabled$ | async) === false"
          [value]="form.get(FORM_FIELDS.SHOW_BEHAVIORS).value"
          (valueChange)="form.get(FORM_FIELDS.SHOW_BEHAVIORS).setValue($event)"></mg-form-toggle>
      </div>

      <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center">
        <div class="tw-flex tw-flex-row tw-items-center">
          <mg-text
            variant="body-sm"
            [color]="
              (isFlexTimeEnabled$ | async) === false && (isCheckinEnabled$ | async) === false ? 'grey-300' : undefined
            ">
            {{ MESSAGES.SETTINGS_SHOW_CHECK_IN }}
          </mg-text>
          <mg-tooltip [label]="MESSAGES.SETTINGS_SHOW_CHECK_IN_TOOLTIP"> </mg-tooltip>
        </div>
        <mg-form-toggle
          [disabled]="(isFlexTimeEnabled$ | async) === false && (isCheckinEnabled$ | async) === false"
          [value]="form.get(FORM_FIELDS.SHOW_CHECK_IN).value"
          (valueChange)="form.get(FORM_FIELDS.SHOW_CHECK_IN).setValue($event)"></mg-form-toggle>
      </div>

      <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center">
        <div class="tw-flex tw-flex-row tw-items-center">
          <mg-text
            variant="body-sm"
            [color]="(isFlexTimeEnabled$ | async) === false ? 'grey-300' : undefined"
            [numberOfLines]="1">
            {{ MESSAGES.SETTINGS_SHOW_FLEXTIME }}
          </mg-text>
          <mg-tooltip [label]="MESSAGES.SETTINGS_SHOW_FLEXTIME_TOOLTIP"> </mg-tooltip>
        </div>
        <mg-form-toggle
          [disabled]="(isFlexTimeEnabled$ | async) === false"
          [value]="form.get(FORM_FIELDS.SHOW_FLEXTIME).value"
          (valueChange)="form.get(FORM_FIELDS.SHOW_FLEXTIME).setValue($event)"></mg-form-toggle>
      </div>
    </div>
  </mat-menu>

  <mat-menu
    #notificationSettings="matMenu"
    xPosition="before">
    <div
      class="tw-flex tw-flex-column tw-gap-2 tw-p-3"
      (click)="$event.stopPropagation()">
      <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center">
        <div class="tw-flex tw-flex-row tw-items-center">
          <mg-text variant="body-sm">
            {{ MESSAGES.SETTINGS_SOUND }}
          </mg-text>
          <mg-tooltip [label]="MESSAGES.SETTINGS_SOUND_TOOLTIP"> </mg-tooltip>
        </div>
        <mg-form-toggle
          [value]="form.get(FORM_FIELDS.ENABLED_SOUND).value"
          (valueChange)="form.get(FORM_FIELDS.ENABLED_SOUND).setValue($event)"></mg-form-toggle>
      </div>
    </div>
  </mat-menu>

  <mat-menu
    #otherSettingsMenu="matMenu"
    xPosition="before">
    <div
      class="tw-flex tw-flex-column tw-gap-2 tw-p-3"
      (click)="$event.stopPropagation()">
      <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center">
        <mg-text variant="body-sm">
          {{ MESSAGES.SETTINGS_SORT_NAME }}
        </mg-text>
        <div class="select-wrap">
          <mg-form-select
            [floatingLabel]="false"
            [condensed]="true"
            [multiple]="false"
            [value]="form.get(FORM_FIELDS.SORT_COLUMN).value"
            [options]="NAME_SORT_OPTIONS"
            [searchable]="false"
            (selectionChanged)="sortNameChanged($event)">
          </mg-form-select>
        </div>
      </div>
      <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center">
        <mg-text variant="body-sm">
          {{ MESSAGES.SETTINGS_DISPLAY_AVATAR }}
        </mg-text>
        <!-- need to use inverse value here since the label was inverse before and we save this to local storage so need to worry about b/c -->
        <mg-form-toggle
          [value]="!form.get(FORM_FIELDS.HIDE_PICTURE_FILTER).value"
          (valueChange)="form.get(FORM_FIELDS.HIDE_PICTURE_FILTER).setValue(!$event)"></mg-form-toggle>
      </div>
    </div>
  </mat-menu>
</div>
